<template>
    <div class="post-back" :style="{backgroundImage:`url(${background?background.toHttps():bkg}?w=1920)`}">
        <div class="fader">
            <div class="container">
                <h1 class='u-c'>{{title}}</h1>
                <div class="date number" v-if="subtitle">{{subtitle}}</div>
                <br />
                <div class="author">{{author}}</div>
                <br />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'post-back',
    props: {
        title: { type: String },
        subtitle: { type: String },
        background: { type: String, default: "" },
        author: { type: String, default: "" }
    },
    computed: {
        bkg() {
            if (!this.$store.state.backgrounds[this.$route.path.replace("/", "")]) return "";
            return this.$store.state.backgrounds[this.$route.path.replace("/", "")].toHttps();
        }
    }
}
</script>
<style lang="css" scoped>
.post-back {
    background-size: cover;
    background-position: center;
    border-bottom: 1px solid lightgrey;

}

.post-back .date {
    color: white;
    font-size: 20px;
}

.post-back h1 {
    font-weight: normal;
    font-family: "Merriweather", sans-serif;
    color: white;
}

.post-back .fader {
    padding-top: 480px;
    padding-bottom: 1px;
    background-color: rgba(0, 0, 0, 0.55);
}

@media(max-width:720px) {
    .post-back .fader {
        padding-top: 220px;
    }
}

.author {
    text-align: right;
    color: white;
}
</style>